/** One of the company's packages, as `GET /company-packages` returns it. */
export interface CompanyPackage {
  id: string; code: string; name: string; description: string | null; version: number;
  defaultFor: 'PRE_EMPLOYMENT' | 'YEARLY' | null; own: boolean; isActive: boolean;
  tests: Array<{ id: string; code: string; name: string; category: string; added: boolean }>;
  removed: Array<{ id: string; code: string; name: string; category: string }>;
}

/** What a package is used for, in the words HR reads it in. */
export function packageUse(p: Pick<CompanyPackage, 'defaultFor' | 'own'>): string {
  if (p.defaultFor === 'PRE_EMPLOYMENT') return 'Used for pre-employment examinations';
  if (p.defaultFor === 'YEARLY') return 'Used for annual and all other examinations';
  return 'Your company\u2019s own package';
}
